"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSectionValueForTracking = exports.VISIBLE_SECTIONS = exports.getTimestepLabel = exports.checkIfSelectedReportTableCellEquals = exports.checkIfSelectedCategoryEquals = exports.isOverTimeOptions = exports.IntervalFilterOptions = exports.IncomeVsExpenseBreakdownTypes = exports.generateDownloadFile = exports.getDownloadFormats = exports.downloadableFileTypes = exports.getChartIconTipLabel = exports.findGroupByCategoryId = exports.getDefaultIsOverTimeFromTabName = exports.getDefaultGroupByFromTabName = exports.convertTabValueToName = exports.convertTabNameToTitle = exports.convertTabNameToValue = exports.getFilterOptionsFromTabName = exports.ChartTypes = exports.Tabs = void 0;
const luxon_1 = require("luxon");
const jspdf_1 = require("jspdf");
require("jspdf-autotable");
const write_excel_file_1 = __importDefault(require("write-excel-file"));
const retrievers_1 = require("data/accounts/retrievers");
const transactions_1 = require("companion-app-components/flux/transactions");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const AmountField_1 = require("components/QuickenControls/AmountField");
const utils_1 = require("utils/utils");
const themeQuicken_1 = require("themes/themeQuicken");
const CURRENCY_FORMAT = '0,00.00';
const SPLIT_STRING = '--- Split ---';
exports.Tabs = {
    SPENDING: 'spending',
    NET_INCOME: 'net-income',
    INCOME_VS_SPENDING: 'income-vs-spending',
};
exports.ChartTypes = {
    BAR: 'bar',
    GROUPED_BAR: 'grouped bar',
    STACKED_BAR: 'stacked bar',
    PIE: 'pie',
    MULTILINE: 'multiline',
    SIDEWAYS_BAR: 'sideways bar',
    INCOME_VS_SPENDING: 'income vs spending',
};
function getFilterOptionsFromTabName(tabName) {
    switch (tabName) {
        case exports.Tabs.SPENDING:
            return [
                { label: 'By category', value: 'category', id: 'breakdown_by_category' },
                { label: 'By payee', value: 'payee', id: 'breakdown_by_payee' },
                // { label: 'By tag', value: 'tag', id: 'breakdown_by_tag' },
                { label: 'None', value: 'none', id: 'breakdown_by_none' },
            ];
        case exports.Tabs.NET_INCOME:
        case exports.Tabs.INCOME_VS_SPENDING:
        default:
            return null;
    }
}
exports.getFilterOptionsFromTabName = getFilterOptionsFromTabName;
function convertTabNameToValue(tabName) {
    switch (tabName) {
        case exports.Tabs.SPENDING:
            return 0;
        case exports.Tabs.NET_INCOME:
            return 1;
        case exports.Tabs.INCOME_VS_SPENDING:
            return 2;
        default:
            return 0;
    }
}
exports.convertTabNameToValue = convertTabNameToValue;
function convertTabNameToTitle(tabName) {
    switch (tabName) {
        case exports.Tabs.SPENDING:
            return 'Reports: Spending';
        case exports.Tabs.NET_INCOME:
            return 'Reports: Net Income';
        case exports.Tabs.INCOME_VS_SPENDING:
            return 'Reports: Income VS. Expense';
        default:
            return 'Reports';
    }
}
exports.convertTabNameToTitle = convertTabNameToTitle;
function convertTabValueToName(tabValue) {
    switch (tabValue) {
        case 0:
            return exports.Tabs.SPENDING;
        case 1:
            return exports.Tabs.NET_INCOME;
        case 2:
            return exports.Tabs.INCOME_VS_SPENDING;
        default:
            return exports.Tabs.SPENDING;
    }
}
exports.convertTabValueToName = convertTabValueToName;
const tabNameToGroupBy = {
    spending: 'category',
};
function getDefaultGroupByFromTabName(tabName) {
    return tabNameToGroupBy[tabName] || null;
}
exports.getDefaultGroupByFromTabName = getDefaultGroupByFromTabName;
const tabNameToIsOverTime = {
    [exports.Tabs.SPENDING]: false,
    [exports.Tabs.NET_INCOME]: true,
    [exports.Tabs.INCOME_VS_SPENDING]: true,
};
function getDefaultIsOverTimeFromTabName(tabName) {
    return tabNameToIsOverTime[tabName];
}
exports.getDefaultIsOverTimeFromTabName = getDefaultIsOverTimeFromTabName;
// searches through the groups object to find a group with a specific category Id
// also builds the breadcrumbs to the group
// TODO: clean this guy up
function findGroupByCategoryId(catId, group, crumbs = []) {
    var _a;
    if (!group)
        return [null, crumbs];
    if (catId === 'EverythingElse' && (group === null || group === void 0 ? void 0 : group.groupKey) === 'Everything else') {
        return [group, crumbs.concat([{ name: group === null || group === void 0 ? void 0 : group.groupKey, categoryId: group.categoryId, total: group.total }])];
    }
    if (group.categoryId === catId)
        return [group, crumbs];
    let groupFound = null;
    let crumbsFound = crumbs;
    (_a = group.subgroups) === null || _a === void 0 ? void 0 : _a.some((subG) => {
        [groupFound, crumbsFound] = findGroupByCategoryId(catId, subG, crumbs.concat([{ name: subG === null || subG === void 0 ? void 0 : subG.groupKey, categoryId: subG.categoryId, total: subG.total }]));
        return groupFound; // will cause .some() to short circuit when the group is found recurseively
    });
    return [groupFound, crumbsFound];
}
exports.findGroupByCategoryId = findGroupByCategoryId;
const getChartIconTipLabel = (chartType) => {
    let label;
    switch (chartType) {
        case exports.ChartTypes.STACKED_BAR:
            label = 'Stack';
            break;
        case exports.ChartTypes.GROUPED_BAR:
        case exports.ChartTypes.INCOME_VS_SPENDING:
            label = 'Cluster';
            break;
        case exports.ChartTypes.SIDEWAYS_BAR:
            label = 'Bar';
            break;
        case exports.ChartTypes.PIE:
            label = 'Pie';
            break;
        default:
            label = '';
    }
    return label;
};
exports.getChartIconTipLabel = getChartIconTipLabel;
const generateHyphens = (number) => '-'.repeat(number);
const tableDSForPdf = (payee, date, accountName, category, amount, type, isGroupKeyEqualsParentGroupKey, isParent, level, currency) => ({
    payee,
    date,
    accountName,
    category,
    amount: (0, AmountField_1.formatNumber)(amount, currency, CURRENCY_FORMAT),
    type,
    level: isGroupKeyEqualsParentGroupKey ? level : Number(level) + 1,
    isParent,
});
const constructPdfColumns = (groupBy, isNotSpendingTab) => {
    let columns = [];
    if (isNotSpendingTab) {
        columns = [
            { header: 'Date', dataKey: 'date' },
            { header: 'Payee', dataKey: 'payee' },
            { header: 'Category', dataKey: 'category' },
            { header: 'Account', dataKey: 'accountName' },
            { header: 'Amount', dataKey: 'amount' },
        ];
    }
    else {
        columns = [
            { header: groupBy === 'category' ? 'Category' : 'Payee', dataKey: 'payee' },
            { header: 'Date', dataKey: 'date' },
            { header: 'Account', dataKey: 'accountName' },
            { header: groupBy === 'category' ? 'Payee' : 'Category', dataKey: 'category' },
            { header: 'Amount', dataKey: 'amount' },
        ];
    }
    return columns;
};
const cellStylingForPdfTable = (row, cell, tabName) => {
    // Table Cell spacing, borders and aligments
    /* eslint-disable no-param-reassign */
    const sectionLineStyle = (lineWidth) => {
        cell.styles.fillColor = themeQuicken_1.theme.components.pdf.white;
        cell.styles.lineColor = themeQuicken_1.theme.components.pdf.black;
        cell.styles.lineWidth = lineWidth;
    };
    const { raw, cells } = row;
    if (row.section === 'body') {
        cell.styles.textColor = themeQuicken_1.theme.components.pdf.black;
        cells[2].styles.cellPadding = { right: 15, top: 10 };
        if (raw.type === 'group') {
            sectionLineStyle({ bottom: 0.1 });
            cell.styles.cellPadding = { top: 10 };
        }
        else if (raw.type === 'groupType') {
            cell.styles.fillColor = themeQuicken_1.theme.components.pdf.cultured;
            cell.styles.lineColor = themeQuicken_1.theme.components.pdf.black;
            cell.styles.cellPadding = { left: 0, right: 0, top: 5, bottom: 5 };
            cells[4].styles.halign = 'right';
        }
        else if (raw.type === 'txn') {
            cell.styles.cellPadding = { top: 10 };
            if (tabName !== exports.Tabs.NET_INCOME && tabName !== exports.Tabs.INCOME_VS_SPENDING) {
                cells[0].styles.cellPadding = { left: ((raw === null || raw === void 0 ? void 0 : raw.level) || 0) * 20, top: 10 };
            }
        }
        else if (raw.type === 'total') {
            cell.styles.fontStyle = 'bold';
            cell.styles.cellPadding = { top: 15 };
            sectionLineStyle({ top: 0.1 });
        }
    }
    else if (row.section === 'head') {
        sectionLineStyle({ bottom: 0.1 });
        cell.styles.textColor = themeQuicken_1.theme.components.pdf.black;
        cell.styles.cellPadding = { left: 0, right: 0 };
        cells[4].styles.halign = 'right';
    }
};
const generateTableForPdf = (doc, txns, groupBy, tabName) => {
    doc.addPage();
    const isNotSpendingTab = (tabName === exports.Tabs.NET_INCOME || tabName === exports.Tabs.INCOME_VS_SPENDING);
    const columns = constructPdfColumns(groupBy, isNotSpendingTab);
    doc.autoTable({
        theme: 'plain',
        body: txns,
        columns,
        columnStyles: {
            accountName: { cellWidth: isNotSpendingTab ? 175 : 200 },
            payee: { cellWidth: 200 },
            category: { cellWidth: isNotSpendingTab ? 175 : 200 },
            date: { cellWidth: isNotSpendingTab ? 120 : 60 },
            amount: { halign: 'right', cellWidth: 100 },
        },
        headStyles: {
            fillColor: false,
            textColor: themeQuicken_1.theme.components.pdf.black,
        },
        didParseCell: ({ row, cell }) => {
            cellStylingForPdfTable(row, cell, tabName);
        },
        didDrawCell: ({ row, cursor, doc: dataDoc, settings }) => {
            // for dashed lines after sub category heads
            const { raw } = row;
            if (row.section === 'body') {
                if (raw.type === 'txn' && raw.isParent) {
                    dataDoc.setLineDashPattern([2, 2], 0);
                    dataDoc.line(settings.margin.left + (raw.level * 20), cursor.y + row.height + 5, dataDoc.internal.pageSize.width - 42, cursor.y + row.height + 5);
                    dataDoc.setLineDashPattern();
                }
            }
        },
        margin: { top: 105 },
    });
};
const setPageHeader = (doc, heading, datePeriod, noTxn, filterText) => {
    const xAxis = doc.internal.pageSize.width / 2;
    doc.setFontSize(14);
    doc.setTextColor(themeQuicken_1.theme.components.pdf.black);
    doc.text(heading, xAxis, 40, { align: 'center' });
    doc.setFontSize(12);
    doc.text(datePeriod, xAxis, 60, { align: 'center', lineHeightFactor: 1 });
    doc.text(filterText, xAxis, 80, { align: 'center', lineHeightFactor: 1 });
    if (noTxn) {
        doc.text('No Transactions', xAxis, doc.internal.pageSize.height / 2, { align: 'center', lineHeightFactor: 1 });
    }
};
const setPdfFooter = (doc, pageCurrent, pageCount, dataset) => {
    doc.setFontSize(10);
    doc.setTextColor(themeQuicken_1.theme.components.pdf.oldSilver);
    doc.text(`Printed from ${dataset === null || dataset === void 0 ? void 0 : dataset.name} on ${luxon_1.DateTime.now().toFormat('MM/dd/yyyy')}`, 20, doc.internal.pageSize.height - 15);
    doc.text(`Page ${pageCurrent}/${pageCount}`, doc.internal.pageSize.width - 70, doc.internal.pageSize.height - 15);
    doc.setTextColor(themeQuicken_1.theme.components.pdf.black);
};
const setPageHeaderAndFooterPdf = (doc, heading, datePeriod, filterText, dataset, noTxn = false) => {
    const pageCount = doc.internal.getNumberOfPages(); // Total Page Number
    for (let count = 0; count <= pageCount; count++) {
        doc.setPage(count);
        const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber; // Current Page
        setPageHeader(doc, heading, datePeriod, noTxn, filterText);
        setPdfFooter(doc, pageCurrent, pageCount, dataset);
    }
};
const querySelectAndUpdateLegends = (total) => {
    // Select the container element
    const target = document.querySelector('#pieLegends');
    if (!target) {
        return null;
    }
    const pieLegends = target.cloneNode(true);
    pieLegends.style.display = 'block';
    // Select all button elements within the container
    const legendButtons = pieLegends.querySelectorAll('button');
    // Loop through each button and update the style and content
    legendButtons.forEach((button) => {
        var _a, _b, _c, _d;
        const elemAmount = button.querySelector('#reports_pie_chart_legend_amount');
        if (!elemAmount) {
            return;
        }
        const legentVal = Number((_b = (_a = elemAmount.innerText) === null || _a === void 0 ? void 0 : _a.replaceAll(',', '')) === null || _b === void 0 ? void 0 : _b.replace('$ ', '')) || 0;
        const totalVal = Number((_c = total === null || total === void 0 ? void 0 : total.replaceAll(',', '')) === null || _c === void 0 ? void 0 : _c.replace('$', '')) || 0;
        const percent = ((legentVal / totalVal) * 100).toFixed(2);
        button.innerHTML += `<div style="font-size: 24px; text-align: end; margin-left: 20px; width: 130px;">${percent}%</div>`;
        // Set the max-width and display style
        button.style.maxWidth = 'max-content';
        // Select the color div and update its style
        const colorDiv = button.querySelector('div:nth-child(1)');
        if (colorDiv) {
            colorDiv.style.marginTop = '10px';
        }
        // Select the text wrapper div and update its style
        const textWrapperDiv = button.querySelector('div:nth-child(2)');
        if (textWrapperDiv) {
            textWrapperDiv.style.flexDirection = 'row';
            textWrapperDiv.style.width = '450px';
            // Select the category text element and update its style
            const categoryText = textWrapperDiv.querySelector('p');
            if (categoryText) {
                categoryText.style.fontSize = '24px';
                categoryText.innerText = categoryText.innerText.length > 25 ? `${categoryText.innerText.substring(0, 20)}...` : categoryText.innerText;
            }
            // Select the amount div element and update its style
            const amountWrapper = textWrapperDiv.querySelector('div');
            if (amountWrapper) {
                amountWrapper.style.margin = '0 0 0 auto';
                const amountText = amountWrapper.querySelector('p');
                if (amountText) {
                    amountText.innerText = (_d = amountText.innerText) === null || _d === void 0 ? void 0 : _d.replace('$ ', '$');
                    amountText.style.fontSize = '24px';
                    amountText.style.paddingLeft = '10px';
                }
            }
        }
    });
    // Add a new button for 'Total' if needed
    const totalButton = document.createElement('div');
    totalButton.style.maxWidth = 'max-content';
    totalButton.style.display = 'flex';
    totalButton.style.paddingLeft = '28px';
    totalButton.innerHTML = `
    <div style="display:flex; flex-direction: row; width: 450px; font-size: 24px; font-weight: 500;">
      <p style="margin: 0;">Total</p>
      <p style="margin: 0 0 0 auto; padding-left: 10px;">${total}</p>
    </div>
  `;
    // Append the 'Total' button to the container
    pieLegends.appendChild(totalButton);
    return pieLegends;
};
const categoryTableDSForCsv = (categoryName, txnDate, txnAccount, payeeName, txnAmount, currency) => ([
    categoryName,
    txnDate,
    txnAccount,
    payeeName,
    `"${(0, AmountField_1.formatNumber)(txnAmount, currency, CURRENCY_FORMAT)}"`,
]);
const tableDSForXlsx = (categoryName, txnDate, txnAccount, payeeName, txnAmount, currency) => ({
    Category: categoryName,
    Date: txnDate,
    Account: txnAccount,
    Payee: payeeName,
    Amount: (0, AmountField_1.formatNumber)(txnAmount, currency, CURRENCY_FORMAT),
});
const constructTableDataForTxnsList = (data, tableData, fileType, coaNodesById, currency) => {
    data === null || data === void 0 ? void 0 : data.get('allTxns').sort((first, second) => luxon_1.DateTime.fromISO(second.postedOn).valueOf() - luxon_1.DateTime.fromISO(first.postedOn).valueOf()).forEach((txn, index) => {
        const coaId = chart_of_accounts_1.chartOfAccountsUtils.getCoaId(txn.coa);
        const txnDate = luxon_1.DateTime.fromISO(txn.postedOn).toFormat('MM/dd/yyyy');
        const txnAccount = (0, retrievers_1.getAccountString)(txn.accountId);
        const txnCategory = transactions_1.transactionsUtils.isSplitTxn(txn) ? SPLIT_STRING : coaNodesById.get(coaId).name || coaId;
        const txnAmount = (0, AmountField_1.formatNumber)(txn.amount, currency, CURRENCY_FORMAT);
        if (fileType === 'pdf') {
            tableData.push(tableDSForPdf(txn.payee, txnDate, txnAccount, txnCategory, txn.amount, 'txn', true, undefined, undefined, currency));
        }
        else if (fileType === 'csv') {
            tableData.push([
                index + 1,
                txnDate,
                txn.payee,
                txnCategory,
                txnAccount,
                `"${txnAmount}"`,
            ]);
        }
        else {
            tableData.push(tableDSForXlsx(txnCategory, txnDate, txnAccount, txn.payee, txn.amount, currency));
        }
    });
};
// eslint-disable-next-line @typescript-eslint/default-param-last
const flatCategoryTreeAndSubTxnsToList = (categoryTree, level = 0, parentGroupKey = '', currency, fileType) => {
    let categoryAndTxnsList = [];
    let itemsWithOthersLabel = [];
    for (const item of categoryTree) { // eslint-disable-line no-restricted-syntax
        let modifiedGroupKey = item === null || item === void 0 ? void 0 : item.groupKey;
        let isGroupKeyEqualsParentGroupKey = false;
        const isParent = item.subgroups.length !== 0;
        if (modifiedGroupKey === parentGroupKey) {
            modifiedGroupKey = `${modifiedGroupKey} (Others)`;
            isGroupKeyEqualsParentGroupKey = true;
        }
        if (categoryTree.length > 1 || (categoryTree.length === 1 && item.subgroups.length > 0)) {
            let categoryOrTxnItem;
            if (fileType === 'pdf') {
                categoryOrTxnItem = tableDSForPdf(modifiedGroupKey, '', '', '', item.total * -1, 'txn', isGroupKeyEqualsParentGroupKey, true, level, currency);
            }
            else if (fileType === 'csv') {
                const categoryName = `${generateHyphens(isGroupKeyEqualsParentGroupKey ? level : level + 1)}${modifiedGroupKey}`;
                categoryOrTxnItem = categoryTableDSForCsv(categoryName, '', '', '', item.total * -1, currency);
            }
            else {
                const categoryName = `${generateHyphens(isGroupKeyEqualsParentGroupKey ? level : level + 1)}${modifiedGroupKey}`;
                categoryOrTxnItem = tableDSForXlsx(categoryName, '', '', '', item.total * -1, currency);
            }
            if (isGroupKeyEqualsParentGroupKey) {
                itemsWithOthersLabel.push(categoryOrTxnItem);
            }
            else {
                categoryAndTxnsList.push(categoryOrTxnItem);
            }
        }
        if (item.subgroups.length > 0) {
            const childItems = flatCategoryTreeAndSubTxnsToList(item.subgroups, level + 1, item === null || item === void 0 ? void 0 : item.groupKey, currency, fileType);
            categoryAndTxnsList = categoryAndTxnsList.concat(childItems.categoryAndTxnsList);
            itemsWithOthersLabel = itemsWithOthersLabel.concat(childItems.itemsWithOthersLabel);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-loop-func
            item.txns.sort((first, second) => luxon_1.DateTime.fromISO(second.postedOn).valueOf() - luxon_1.DateTime.fromISO(first.postedOn).valueOf()).forEach((txn) => {
                let txnAmount = txn === null || txn === void 0 ? void 0 : txn.amount;
                if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
                    const getAmountFromSplit = txn.split.items.find(({ coa }) => coa.id === item.categoryId);
                    if (getAmountFromSplit) {
                        txnAmount = getAmountFromSplit.amount;
                    }
                }
                const txnDate = luxon_1.DateTime.fromISO(txn === null || txn === void 0 ? void 0 : txn.postedOn).toFormat('MM/dd/yyyy');
                const txnAccount = (0, retrievers_1.getAccountString)(txn === null || txn === void 0 ? void 0 : txn.accountId);
                let categoryOrTxnItem;
                if (fileType === 'pdf') {
                    categoryOrTxnItem = tableDSForPdf('', txnDate, txnAccount, (txn === null || txn === void 0 ? void 0 : txn.payee) || '', txnAmount, 'txn', false, isParent, level, currency);
                }
                else if (fileType === 'csv') {
                    categoryOrTxnItem = categoryTableDSForCsv('', txnDate, txnAccount, (txn === null || txn === void 0 ? void 0 : txn.payee) || '', txnAmount, currency);
                }
                else {
                    categoryOrTxnItem = tableDSForXlsx('', txnDate, txnAccount, (txn === null || txn === void 0 ? void 0 : txn.payee) || '', txnAmount, currency);
                }
                if (isGroupKeyEqualsParentGroupKey) {
                    itemsWithOthersLabel.push(categoryOrTxnItem);
                }
                else {
                    categoryAndTxnsList.push(categoryOrTxnItem);
                }
            });
        }
    }
    return { categoryAndTxnsList: categoryAndTxnsList.concat(itemsWithOthersLabel).filter((item) => item), itemsWithOthersLabel: [] };
};
const tableDataForPdf = (data, coaNodesById, groupBy, tabName, currency) => {
    var _a, _b, _c, _d;
    const tableData = [];
    const byPayee = groupBy === 'payee';
    const total = Number(data === null || data === void 0 ? void 0 : data.get('total'));
    const totalRawReport = Number(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'));
    if (groupBy === 'category') {
        tableData.unshift(tableDSForPdf('Expenses', undefined, undefined, undefined, total, 'groupType', true, undefined, 0, currency));
    }
    (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _a === void 0 ? void 0 : _a.spendings) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.subgroups) === null || _d === void 0 ? void 0 : _d.forEach((group) => {
        var _a;
        tableData.push(tableDSForPdf(group.originalKey || (group === null || group === void 0 ? void 0 : group.groupKey), undefined, undefined, undefined, group.total * -1, 'group', true, undefined, 0, currency));
        if (groupBy !== 'category') {
            (_a = group === null || group === void 0 ? void 0 : group.txns) === null || _a === void 0 ? void 0 : _a.sort((first, second) => luxon_1.DateTime.fromISO(second.postedOn).valueOf() - luxon_1.DateTime.fromISO(first.postedOn).valueOf()).forEach((txn) => {
                const coaId = chart_of_accounts_1.chartOfAccountsUtils.getCoaId(txn.coa);
                let payeeName = txn.payee;
                let levelAssigned = 0;
                if (byPayee && (group === null || group === void 0 ? void 0 : group.groupKey) === 'Everything else') {
                    payeeName = txn.payee;
                    levelAssigned = 1;
                }
                else if (byPayee) {
                    payeeName = null;
                }
                const txnObj = {
                    payee: payeeName,
                    accountName: (0, retrievers_1.getAccountString)(txn.accountId),
                    category: transactions_1.transactionsUtils.isSplitTxn(txn) ? SPLIT_STRING : coaNodesById.get(coaId).name || coaId,
                    date: luxon_1.DateTime.fromISO(txn.postedOn).toFormat('MM/dd/yyyy'),
                    amount: (0, AmountField_1.formatNumber)(txn.amount, currency, CURRENCY_FORMAT),
                    type: 'txn',
                    level: levelAssigned,
                };
                tableData.push(txnObj);
            });
        }
        else {
            const { categoryAndTxnsList } = flatCategoryTreeAndSubTxnsToList(group === null || group === void 0 ? void 0 : group.subgroups, 0, group === null || group === void 0 ? void 0 : group.groupKey, currency, 'pdf');
            tableData.push(...categoryAndTxnsList);
        }
    });
    if (tabName === exports.Tabs.NET_INCOME || tabName === exports.Tabs.INCOME_VS_SPENDING) {
        constructTableDataForTxnsList(data, tableData, 'pdf', coaNodesById, currency);
    }
    if (tabName !== exports.Tabs.NET_INCOME && tabName !== exports.Tabs.INCOME_VS_SPENDING) {
        tableData.push(tableDSForPdf('OVERALL TOTAL', undefined, undefined, undefined, total, 'total', true, undefined, 0, currency));
    }
    if (tabName === exports.Tabs.NET_INCOME) {
        tableData.push(tableDSForPdf('', 'OVERALL NET INCOME', undefined, undefined, total, 'total', true, undefined, 0, currency));
    }
    else if (tabName === exports.Tabs.INCOME_VS_SPENDING) {
        tableData.push(tableDSForPdf('', 'TOTAL INCOME', undefined, undefined, total - totalRawReport, 'total', true, undefined, 0, currency), tableDSForPdf('', 'TOTAL EXPENSE', undefined, undefined, totalRawReport, 'total', true, undefined, 0, currency), tableDSForPdf('', 'OVERALL NET INCOME', undefined, undefined, total, 'total', true, undefined, 0, currency));
    }
    return tableData;
};
const generateFilterText = (filter) => {
    var _a, _b, _c, _d;
    let filterText = 'All Accounts, All Categories, All Tags, All Payees';
    if (filter) {
        filterText = 'accountCount Accounts, categoriesCount Categories, tagsCount Tags, payessCount Payees';
        filterText = filterText.replace('accountCount', ((_a = filter === null || filter === void 0 ? void 0 : filter.accounts) === null || _a === void 0 ? void 0 : _a.size) ? filter.accounts.size : 'All');
        filterText = filterText.replace('categoriesCount', ((_b = filter === null || filter === void 0 ? void 0 : filter.categories) === null || _b === void 0 ? void 0 : _b.size) ? filter.categories.size : 'All');
        filterText = filterText.replace('tagsCount', ((_c = filter === null || filter === void 0 ? void 0 : filter.tags) === null || _c === void 0 ? void 0 : _c.size) ? filter.tags.size : 'All');
        filterText = filterText.replace('payessCount', ((_d = filter === null || filter === void 0 ? void 0 : filter.payees) === null || _d === void 0 ? void 0 : _d.size) ? filter.payees.size : 'All');
    }
    return filterText;
};
const generatePdf = ({ data, chartType, graphRef, coaNodesById, currency, dateRange, tabName, groupBy, filter, dataset, cb }) => {
    var _a, _b, _c;
    const datePeriod = `${luxon_1.DateTime.fromISO((_a = dateRange === null || dateRange === void 0 ? void 0 : dateRange.value) === null || _a === void 0 ? void 0 : _a.s).toFormat('MM/dd/yyyy')} through ${luxon_1.DateTime.fromISO((_b = dateRange === null || dateRange === void 0 ? void 0 : dateRange.value) === null || _b === void 0 ? void 0 : _b.e).toFormat('MM/dd/yyyy')}`;
    let heading = '';
    const total = (0, AmountField_1.formatNumber)(Number(data === null || data === void 0 ? void 0 : data.get('total')) * (tabName === exports.Tabs.SPENDING ? -1 : 1), currency, CURRENCY_FORMAT);
    if (tabName === exports.Tabs.SPENDING) {
        heading += `${(0, utils_1.capitalize)(tabName)} by ${(0, utils_1.capitalize)(groupBy)} - ${dateRange === null || dateRange === void 0 ? void 0 : dateRange.label}`;
    }
    else if (tabName === exports.Tabs.NET_INCOME) {
        heading += `Net Income - ${dateRange === null || dateRange === void 0 ? void 0 : dateRange.label}`;
    }
    else if (tabName === exports.Tabs.INCOME_VS_SPENDING) {
        heading += `Income vs Expense - ${dateRange === null || dateRange === void 0 ? void 0 : dateRange.label}`;
    }
    const filterText = generateFilterText(filter);
    if ((data === null || data === void 0 ? void 0 : data.get('allTxns').size) === 0 && (data === null || data === void 0 ? void 0 : data.get('total')) === 0) {
        const doc = new jspdf_1.jsPDF('l', 'pt', 'a4'); // eslint-disable-line new-cap
        setPageHeaderAndFooterPdf(doc, heading, datePeriod, filterText, dataset, true);
        doc.save(`${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.pdf`);
        cb();
        return;
    }
    const tableContents = tableDataForPdf(data, coaNodesById, groupBy, tabName, currency);
    const graphImage = (_c = graphRef === null || graphRef === void 0 ? void 0 : graphRef.current) === null || _c === void 0 ? void 0 : _c.getGraphImage();
    if (graphImage) {
        graphImage.then((graphImg) => {
            const doc = new jspdf_1.jsPDF('l', 'pt', 'a4'); // eslint-disable-line new-cap
            const xAxis = doc.internal.pageSize.width / 2;
            doc.setFontSize(14);
            if (tabName === exports.Tabs.NET_INCOME) {
                doc.text(`Overall Net Income: ${total}`, xAxis, 110, { align: 'center' });
            }
            else if (tabName === exports.Tabs.INCOME_VS_SPENDING) {
                doc.text(`Overall Net Income: ${total}`, xAxis, 110, { align: 'center' });
                doc.setFontSize(12);
                doc.text(`Total Income: ${(0, AmountField_1.formatNumber)(Number(data === null || data === void 0 ? void 0 : data.get('total')) - Number(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total')), currency, CURRENCY_FORMAT)} | Total Expense: ${(0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'), currency, CURRENCY_FORMAT)}`, xAxis, 130, { align: 'center' });
            }
            doc.setFontSize(12);
            if (chartType === exports.ChartTypes.PIE) {
                const graphContents = querySelectAndUpdateLegends(total);
                generateTableForPdf(doc, tableContents, groupBy, tabName);
                if (graphContents) {
                    doc.html(graphContents, {
                        callback: (document) => {
                            document.addImage(graphImg, 'PNG', 80, 120, 350, 350);
                            setPageHeaderAndFooterPdf(document, heading, datePeriod, filterText, dataset, false);
                            document.save(`${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.pdf`);
                            cb();
                        },
                        x: 450,
                        y: 170,
                        width: 400,
                        windowWidth: 850,
                    });
                }
            }
            else {
                doc.addImage(graphImg, 'PNG', 120, 160, 600, 0);
                generateTableForPdf(doc, tableContents, groupBy, tabName);
                setPageHeaderAndFooterPdf(doc, heading, datePeriod, filterText, dataset, false);
                doc.save(`${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.pdf`);
                cb();
            }
        });
    }
};
exports.downloadableFileTypes = {
    csv: 'csv',
    xlsx: 'xlsx',
    pdf: 'pdf',
};
const getDownloadFormats = (hidePdfOption = false) => {
    const arrOptions = [
        {
            label: 'Excel (.xlsx)',
            value: exports.downloadableFileTypes.xlsx,
            id: exports.downloadableFileTypes.xlsx,
        },
        {
            label: 'CSV (.csv)',
            value: exports.downloadableFileTypes.csv,
            id: exports.downloadableFileTypes.csv,
        },
    ];
    if (!hidePdfOption) {
        arrOptions.push({
            label: 'PDF (.pdf)',
            value: exports.downloadableFileTypes.pdf,
            id: exports.downloadableFileTypes.pdf,
        });
    }
    return arrOptions;
};
exports.getDownloadFormats = getDownloadFormats;
const generateTableData = (data, coaNodesById, tabName, groupBy, currency, fileType) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const tableData = [];
    if (tabName === exports.Tabs.SPENDING && groupBy !== 'none') {
        const total = (0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('total'), currency, CURRENCY_FORMAT);
        if (groupBy === 'payee') {
            if (fileType === 'csv') {
                tableData.push(['Payee', 'Date', 'Account', 'Category', 'Amount']);
            }
            (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _a === void 0 ? void 0 : _a.spendings) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.subgroups) === null || _d === void 0 ? void 0 : _d.forEach((group) => {
                var _a;
                if (fileType === 'csv') {
                    tableData.push([group.originalKey || (group === null || group === void 0 ? void 0 : group.groupKey), '', '', '', `"${(0, AmountField_1.formatNumber)(group.total * -1, currency, CURRENCY_FORMAT)}"`]);
                }
                else {
                    tableData.push({
                        Payee: group.originalKey || (group === null || group === void 0 ? void 0 : group.groupKey),
                        Date: '',
                        Account: '',
                        Category: '',
                        Amount: (0, AmountField_1.formatNumber)(group.total * -1, currency, CURRENCY_FORMAT),
                    });
                }
                (_a = group === null || group === void 0 ? void 0 : group.txns) === null || _a === void 0 ? void 0 : _a.sort((first, second) => luxon_1.DateTime.fromISO(second.postedOn).valueOf() - luxon_1.DateTime.fromISO(first.postedOn).valueOf()).forEach((txn) => {
                    const coaId = chart_of_accounts_1.chartOfAccountsUtils.getCoaId(txn.coa);
                    const txnDate = luxon_1.DateTime.fromISO(txn.postedOn).toFormat('MM/dd/yyyy');
                    const txnAccount = (0, retrievers_1.getAccountString)(txn.accountId);
                    const txnCategory = transactions_1.transactionsUtils.isSplitTxn(txn) ? SPLIT_STRING : coaNodesById.get(coaId).name || coaId;
                    const txnAmount = (0, AmountField_1.formatNumber)(txn.amount, currency, CURRENCY_FORMAT);
                    if (fileType === 'csv') {
                        tableData.push([
                            (group === null || group === void 0 ? void 0 : group.groupKey) === 'Everything else' ? `-${txn.payee}` : '',
                            txnDate,
                            txnAccount,
                            txnCategory,
                            `"${txnAmount}"`
                        ]);
                    }
                    else {
                        tableData.push({
                            Payee: (group === null || group === void 0 ? void 0 : group.groupKey) === 'Everything else' ? `-${txn.payee}` : '',
                            Date: txnDate,
                            Account: txnAccount,
                            Category: txnCategory,
                            Amount: txnAmount,
                        });
                    }
                });
            });
        }
        else if (groupBy === 'category') {
            if (fileType === 'csv') {
                tableData.push(['Category', 'Date', 'Account', 'Payee', 'Amount'], ['Expenses', '', '', '', `"${total}"`]);
            }
            else {
                tableData.push(tableDSForXlsx('Expenses', '', '', '', data === null || data === void 0 ? void 0 : data.get('total'), currency));
            }
            (_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _e === void 0 ? void 0 : _e.spendings) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.subgroups) === null || _h === void 0 ? void 0 : _h.forEach((group) => {
                if (fileType === 'csv') {
                    tableData.push([group === null || group === void 0 ? void 0 : group.groupKey, '', '', '', `"${(0, AmountField_1.formatNumber)(group.total * -1, currency, CURRENCY_FORMAT)}"`]);
                }
                else {
                    tableData.push(tableDSForXlsx(group === null || group === void 0 ? void 0 : group.groupKey, '', '', '', group.total * -1, currency));
                }
                const { categoryAndTxnsList } = flatCategoryTreeAndSubTxnsToList(group === null || group === void 0 ? void 0 : group.subgroups, 0, group === null || group === void 0 ? void 0 : group.groupKey, currency, fileType);
                tableData.push(...categoryAndTxnsList);
            });
        }
        if (fileType === 'csv') {
            tableData.push(['OVERALL TOTAL', '', '', '', `"${total}"`]);
        }
        else {
            tableData.push({
                [groupBy === 'category' ? 'Category' : 'Payee']: 'OVERALL TOTAL',
                Date: '',
                Account: '',
                [groupBy === 'category' ? 'Payee' : 'Category']: '',
                Amount: total,
            });
        }
    }
    else {
        if (fileType === 'csv') {
            tableData.push(['Id', 'Date', 'Payee', 'Category', 'Account', 'Amount']);
        }
        constructTableDataForTxnsList(data, tableData, fileType, coaNodesById, currency);
        if (tabName === exports.Tabs.NET_INCOME) {
            if (fileType === 'csv') {
                tableData.push(['', 'OVERALL NET INCOME', '', '', '', `"${(0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('total'), currency, CURRENCY_FORMAT)}"`]);
            }
            else {
                tableData.push(tableDSForXlsx('', 'OVERALL NET INCOME', '', '', data === null || data === void 0 ? void 0 : data.get('total'), currency));
            }
        }
        else if (tabName === exports.Tabs.INCOME_VS_SPENDING) {
            const totalDifference = Number(data === null || data === void 0 ? void 0 : data.get('total')) - Number(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'));
            if (fileType === 'csv') {
                tableData.push(['', 'TOTAL INCOME', '', '', '', `"${(0, AmountField_1.formatNumber)(totalDifference, currency, CURRENCY_FORMAT)}"`]);
                tableData.push(['', 'TOTAL EXPENSE', '', '', '', `"${(0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'), currency, CURRENCY_FORMAT)}"`]);
                tableData.push(['', 'OVERALL NET INCOME', '', '', '', `"${(0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('total'), currency, CURRENCY_FORMAT)}"`]);
            }
            else {
                tableData.push(tableDSForXlsx('', 'TOTAL INCOME', '', '', totalDifference, currency), tableDSForXlsx('', 'TOTAL EXPENSE', '', '', data === null || data === void 0 ? void 0 : data.get('rawReport').get('total'), currency), tableDSForXlsx('', 'OVERALL NET INCOME', '', '', data === null || data === void 0 ? void 0 : data.get('total'), currency));
            }
        }
        if (groupBy === 'none') {
            const total = (0, AmountField_1.formatNumber)(data === null || data === void 0 ? void 0 : data.get('total'), currency, CURRENCY_FORMAT);
            if (fileType === 'csv') {
                tableData.push(['', 'OVERALL TOTAL', '', '', '', `"${total}"`]);
            }
            else {
                tableData.push(tableDSForXlsx('', 'OVERALL TOTAL', '', '', data === null || data === void 0 ? void 0 : data.get('total'), currency));
            }
        }
    }
    return tableData;
};
const generateCsv = ({ data, coaNodesById, tabName, groupBy, currency, dataset, cb }) => {
    const tableData = generateTableData(data, coaNodesById, tabName, groupBy, currency, 'csv');
    const csvContent = `data:text/csv;charset=utf-8, ${tableData.map((e) => e.join(',')).join('\n')}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.csv`);
    document.body.appendChild(link);
    link.click();
    cb();
};
const generateXlsx = ({ data, coaNodesById, tabName, groupBy, currency, dataset, cb }) => __awaiter(void 0, void 0, void 0, function* () {
    const tableData = generateTableData(data, coaNodesById, tabName, groupBy, currency, 'xlsx');
    const schema = [];
    let schemaOrder = [];
    if (tabName === exports.Tabs.SPENDING && groupBy !== 'none') {
        if (groupBy === 'category') {
            schemaOrder = ['Category', 'Date', 'Account', 'Payee', 'Amount'];
        }
        else {
            schemaOrder = ['Payee', 'Date', 'Account', 'Category', 'Amount'];
        }
    }
    else {
        schemaOrder = ['Date', 'Payee', 'Category', 'Account', 'Amount'];
    }
    schemaOrder.forEach((header) => {
        schema.push({
            column: header,
            type: String,
            value: (val) => val[header],
            align: header === 'Amount' ? 'right' : 'left',
        });
    });
    yield (0, write_excel_file_1.default)(tableData, {
        schema,
        fileName: `${(0, utils_1.capitalize)(dataset.name)}_${(0, utils_1.capitalize)(tabName)}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.xlsx`,
    });
    cb();
});
const generateDownloadFile = (objParams) => ({
    [exports.downloadableFileTypes.pdf]: () => generatePdf(Object.assign({}, objParams)),
    [exports.downloadableFileTypes.csv]: () => generateCsv(Object.assign({}, objParams)),
    [exports.downloadableFileTypes.xlsx]: () => generateXlsx(Object.assign({}, objParams)),
});
exports.generateDownloadFile = generateDownloadFile;
exports.IncomeVsExpenseBreakdownTypes = [
    { id: 'none', label: 'None' },
    { id: 'category', label: 'Category' },
];
exports.IntervalFilterOptions = [
    { label: 'Monthly', value: 'months', id: 'monthly' },
    { label: 'Quarterly', value: 'quarters', id: 'quarterly' },
];
exports.isOverTimeOptions = [
    { label: 'Total', value: 'total', id: 'total_total' },
    { label: 'Over time', value: 'over-time', id: 'total_over_time' },
];
const checkIfSelectedCategoryEquals = (selectedCategory, compareWithCategory) => selectedCategory === compareWithCategory;
exports.checkIfSelectedCategoryEquals = checkIfSelectedCategoryEquals;
const checkIfSelectedReportTableCellEquals = (selectedCell, categoryId, category) => selectedCell === `${categoryId}-${category}`;
exports.checkIfSelectedReportTableCellEquals = checkIfSelectedReportTableCellEquals;
const getTimestepLabel = (timeStep, date, isLastIndex, periodEndDate) => {
    let endDate = date.plus({ month: 2 });
    if (isLastIndex && periodEndDate && timeStep === 'quarters') {
        endDate = periodEndDate;
    }
    const yearWithOrWithoutMonth = timeStep === 'years' ? 'yyyy' : 'LLL yy';
    return timeStep !== 'quarters'
        ? date.toFormat(timeStep === 'days' ? 'd' : yearWithOrWithoutMonth)
        : `${date.toFormat('LLL')} - ${endDate.toFormat('LLL')} (${date.toFormat('yyyy')})`;
};
exports.getTimestepLabel = getTimestepLabel;
exports.VISIBLE_SECTIONS = {
    graph: 'graph',
    report: 'report',
};
const getSectionValueForTracking = (selectedBreakdownId, visibleSection, forSection) => selectedBreakdownId === exports.IncomeVsExpenseBreakdownTypes[0].id ? 'null' : visibleSection === forSection;
exports.getSectionValueForTracking = getSectionValueForTracking;
